import { IBaseModel } from '../base/base-model.interface';
import { AccessType } from '../locations/location.interface';
import { createEnumOptions } from '../shared/enum-option.interface';

export enum ReportState {
  Draft = 'draft',
  Published = 'published',
  Approved = 'approved',
  Rejected = 'rejected',
  Archived = 'archived',
}

export enum ReportType {
  Rent = 1,
  Migration = 2,
}

export enum GeneratorStatus {
  pending = 'pending',
  processing = 'processing',
  failed = 'failed',
  success = 'success',
}

export interface IReport extends IBaseModel<'Report'> {
  startDate?: Date;
  endDate?: Date;
  lastGeneratedDate?: Date;
  groupId?: string;
  internalId?: string;
  state: ReportState;

  count?: number;
  priceBase?: number;
  priceColocation?: number;
  priceRemotegateZa?: number;
  priceRemotegateBa?: number;
  priceService?: number;
  priceCamera?: number;
  priceOvercapacity?: number;
  priceUndocumented?: number;
  priceCashback?: number;
  priceFinal?: number;
  priceMigrationIn?: number;
  priceMigrationOut?: number;
  priceAllMigrationsIn?: number;
  priceColocationsSp?: number;
  priceColocationsIsp?: number;

  countColocation?: number;
  countRemotegateZa?: number;
  countRemotegateBa?: number;
  countService?: number;
  countCamera?: number;
  countCashback?: number;
  countUndocumented?: number;
  countMigrationOut?: number;
  countColocationsSp?: number;
  countColocationsIsp?: number;

  overcapacity?: number;
  generatorStatus?: GeneratorStatus;
  data: IReportData[];
}

export interface IReportData {
  reportId: string;
  cityHash: string;
  oltName?: string;

  county?: string;
  city?: string;
  district?: string;

  accessType?: AccessType;

  count?: number;
  price?: number;

  cashbackCount?: number;
  cashbackPrice?: number;
  serviceCount?: number;
  servicePrice?: number;

  countColocationsSp?: number;
  countColocationsIsp?: number;
  priceColocationsSp?: number;
  priceColocationsIsp?: number;
  priceColocationsIspSetupFee?: number;
  undocumentedCount?: number;
  undocumentedPrice?: number;
}

export interface IReportOrder {
  orderId: string;
  extOrderId?: string;
  ontSn?: string;
  reportId: string;
  activationDate?: Date;
  closeDate?: Date;
  accessType?: AccessType;
  apId?: string;
  locationHash?: string;
  price?: number;
  county?: string;
  city?: string;
  district?: string;
  address?: string;
  cashback?: boolean;
  cashbackPrice?: number;
  servicePrice?: number;
  undocumentedPrice?: number;
  groupId?: string;
  cashbackGroupId?: string;
  servicePartnerGroupId?: string;
}

export interface IReportDataRaw {
  id: string;
}

export const reportStateOptions = createEnumOptions<ReportState>({
  [ReportState.Draft]: { label: 'Rozpracovaný', color: 'warn' },
  [ReportState.Published]: { label: 'Zverejnený', color: 'primary' },
  [ReportState.Approved]: { label: 'Schválený', color: 'success' },
  [ReportState.Rejected]: { label: 'Zamietnutý', color: 'danger' },
  [ReportState.Archived]: { label: 'Archivovaný', color: 'none' },
  _default: { label: '-', color: 'none' },
});

export const reportTypeOptions = createEnumOptions<ReportType>({
  [ReportType.Migration]: { label: 'Migrácia' },
  [ReportType.Rent]: { label: 'Prenájom OM' },
  _default: { label: '-' },
});

export const reportGeneratorStatusOptions = createEnumOptions<GeneratorStatus>({
  [GeneratorStatus.pending]: { label: 'Čaká na vygenerovanie', color: 'warn' },
  [GeneratorStatus.processing]: { label: 'Generuje sa', color: 'warn' },
  [GeneratorStatus.failed]: { label: 'Chyba pri generovaní', color: 'danger' },
  [GeneratorStatus.success]: { label: 'Vygenerovaný', color: 'success' },
  _default: { label: '-' },
});

export interface IReportInternalIdConfig {
  template: string;
}

export interface IReportsConfig {
  internalIdConfig: IReportInternalIdConfig | null;
}

export const REPORT_INTERNAL_ID_TEMPLATE_TOKENS = [
  'YY',
  'YYYY',
  'MM',
  'PARTNER',
  'TYPE',
  'COUNT',
] as const;

export type ReportInternalIdTemplateToken =
  (typeof REPORT_INTERNAL_ID_TEMPLATE_TOKENS)[number];
